import { fetchFlask } from '../../utils/fetchFlask';
import { parseNumberPtBrOrThrow } from '../../utils/numberUtils';
import { isBlank } from '../../utils/stringFormat';

export const npsScoreOptions = [2, 4, 6, 8, 10];

export const fetchNpsMes = async (mes) => {
    const response = await fetchFlask('getNpsMes', JSON.stringify({ mes }));
    return response.nps;
};

export const parseNpsScore = (value) => (
    isBlank(value)
        ? 0
        : parseNumberPtBrOrThrow(value, `Nota inválida recebida para NPS: ${value}`)
);

export const buildNpsSummary = (nps) => {
    const totalRespondents = nps.length;
    const totalScore = nps.reduce((total, response) => total + parseNpsScore(response.nota), 0);
    const averageScore = totalRespondents ? totalScore / totalRespondents : 0;
    const satisfiedRespondents = nps
        .filter((response) => {
            const score = parseNpsScore(response.nota);
            return score === 8 || score === 10;
        })
        .length;

    return {
        totalRespondents,
        averageScore,
        csatScore: totalRespondents ? (satisfiedRespondents / totalRespondents) * 100 : 0,
        target: 75
    };
};

export const buildNpsDistribution = (nps) => {
    const totalRespondents = nps.length;
    const countByScore = new Map(npsScoreOptions.map((score) => [score, 0]));

    nps.forEach((response) => {
        const score = parseNpsScore(response.nota);
        countByScore.set(score, (countByScore.get(score) || 0) + 1);
    });

    return npsScoreOptions.map((score) => {
        const count = countByScore.get(score) || 0;

        return {
            score,
            count,
            percentage: totalRespondents ? count / totalRespondents : 0
        };
    });
};

export const buildNpsRows = (nps) => nps
    .map((response, index) => ({
        id: `${response.cliente_id}-${response.data_pesquisa}-${index}`,
        clienteId: response.cliente_id,
        cliente: response.cliente,
        dataPesquisa: response.data_pesquisa,
        nota: parseNpsScore(response.nota),
        comentario: response.comentario || ''
    }));
